import moment from "moment";

// setting default time zone

export const makeStamp = (date, _startTime, _endTime) => {
  const shift = {
    span: "",
    startTimeHour: 0,
    endTimeHour: 0,
  };
  //* Determine Shift Span (AM-PM, AM-AM, PM-PM, PM-AM)

  let shiftSpan = "";
  [_startTime, _endTime].map((time, index) => {
    let hour = moment(time, "h:mm A").hour();
    if (hour < 12) {
      shiftSpan += "AM";
    } else {
      shiftSpan += "PM";
    }
    shiftSpan += " ";

    if (index == 0) {
      shift.startTimeHour = hour;
    }
    if (index == 1) {
      shift.endTimeHour = hour;
      shift.span = shiftSpan.trim();
    }
  });
  let startTime = moment(`${date} ${_startTime}`, "YYYY-MM-DD h:mm A");
  let endTime;
  if (areTimestampsOnSameDay(_startTime, _endTime) && _startTime !== _endTime) {
    endTime = moment(`${date} ${_endTime}`, "YYYY-MM-DD h:mm A");
  } else {
    endTime = moment(`${date} ${_endTime}`, "YYYY-MM-DD h:mm A").add(1, "d");
  }

  let stamp = {
    startTime: startTime.format("YYYY-MM-DD h:mm A"),
    endTime: endTime.format("YYYY-MM-DD h:mm A"),
  };
  return stamp;
};

export const validDate = (date) => {
  date = moment(date).format("YYYY-MM-DD");
  const today = moment(new Date()).format("YYYY-MM-DD");

  if (moment(date).isSame(today, "day")) {
    return true;
  } else if (moment(today).isBefore(date)) {
    return true;
  }
  return false;
};

export const validTime = (date, _startTime, _endTime) => {
  const { startTime, endTime } = makeStamp(date, _startTime, _endTime);

  const now = moment().format("YYYY-MM-DD hh:mm A");

  const time = moment(now);

  if (time.isBefore(startTime)) {
    return true;
  }

  if (time.isBetween(startTime, endTime)) {
    return true;
  }

  return false;
};

export const currentTime = (date, _startTime, _endTime) => {
  const { startTime, endTime } = makeStamp(date, _startTime, _endTime);

  const now = moment().format("YYYY-MM-DD hh:mm A");

  const s = moment(startTime);
  const e = moment(endTime);
  const time = moment(now);

  if (time.isBetween(s, e)) {
    return true;
  }

  return false;
};

export const shiftTime = {
  to: (time) => {
    const parsedTime = moment(time, "hh:mm");
    const formattedTime = parsedTime.format("hh:mm A");

    return formattedTime;
  },
  from: (time) => {
    return moment(time, "hh:mm A").format("HH:mm");
  },
};

const parseTimeString = (time) => {
  const format = time.includes("PM") ? "hh:mm A" : "hh:mm a";
  return moment(time, format);
};

const areTimestampsOnSameDay = (time1, time2) => {
  const dateTime1 = parseTimeString(time1);
  const dateTime2 = parseTimeString(time2);

  if (dateTime2.isBefore(dateTime1)) {
    dateTime2.add(1, "days");
  }

  return dateTime1.isSame(dateTime2, "day");
};
